"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _utils = require("../decorators/utils");

var capitalize = function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
};

var consumerDecoratorFactory = function consumerDecoratorFactory(contextName, Consumer, propName) {
  return function (Component) {
    var contextPropName = propName || contextName + "Context";

    var ConsumesContextComponent =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(ConsumesContextComponent, _React$Component);

      function ConsumesContextComponent() {
        (0, _classCallCheck2.default)(this, ConsumesContextComponent);
        return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ConsumesContextComponent).apply(this, arguments));
      }

      (0, _createClass2.default)(ConsumesContextComponent, [{
        key: "render",
        value: function render() {
          var _this = this;

          this._refCallback = this._refCallback || (0, _utils.makeDecoratorRefCallback)(Component, this);
          return _react.default.createElement(Consumer, null, function (context) {
            var props = (0, _extends3.default)({}, _this.props, (0, _defineProperty2.default)({}, contextPropName, context));
            return _react.default.createElement(Component, (0, _extends3.default)({}, props, {
              ref: _this._refCallback
            }));
          });
        }
      }]);
      return ConsumesContextComponent;
    }(_react.default.Component); // Omit context prop from propTypes


    ConsumesContextComponent.propTypes = (0, _extends3.default)({}, Component.propTypes);
    delete ConsumesContextComponent.propTypes[contextPropName];
    ConsumesContextComponent.defaultProps = Component.defaultProps;
    ConsumesContextComponent.displayName = "Consumes" + capitalize(contextName) + "Context(" + (0, _getComponentName.default)(Component) + ")";
    (0, _utils.attachWrappedComponent)(ConsumesContextComponent, Component);
    return ConsumesContextComponent;
  };
};

var _default = consumerDecoratorFactory;
exports.default = _default;
module.exports = exports.default;